import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { PaymentRequestsInitialState } from '../globalSlices/paymentRequestsSlice';
import {
  createPaymentRequest,
  deletePaymentRequest,
  getPaymentRequestDetailsForPayment,
  getPaymentRequests,
  paymentRequestFiservPayment,
  paymentRequestPayment,
  resendPaymentRequest,
  updatePaymentRequest,
} from '../services/paymentRequestsService';

export const createPaymentRequestExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentRequestsInitialState>
) => {
  const reducerId = 'createPaymentRequest';
  builder.addCase(createPaymentRequest.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(createPaymentRequest.fulfilled, (state, action) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    if (action.payload && action.payload.success && action.payload?.data) {
    } else {
    }
  });
  builder.addCase(createPaymentRequest.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const getPaymentRequestsExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentRequestsInitialState>
) => {
  const reducerId = 'getPaymentRequests';
  builder.addCase(getPaymentRequests.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(getPaymentRequests.fulfilled, (state, action) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    if (action.payload && action.payload.success && action.payload?.data) {
      state.paymentRequests = action.payload?.data.data;
    } else {
    }
  });
  builder.addCase(getPaymentRequests.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
export const getPaymentRequestDetailsForPaymentExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentRequestsInitialState>
) => {
  const reducerId = 'getPaymentRequestDetailsForPayment';
  builder.addCase(getPaymentRequestDetailsForPayment.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(getPaymentRequestDetailsForPayment.fulfilled, (state, action) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
  builder.addCase(
    getPaymentRequestDetailsForPayment.rejected,
    (state, action: PayloadAction<any>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
};

export const paymentRequestPaymentExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentRequestsInitialState>
) => {
  const reducerId = 'paymentRequestPayment';
  builder.addCase(paymentRequestPayment.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(paymentRequestPayment.fulfilled, (state, action) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
  builder.addCase(paymentRequestPayment.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const paymentRequestFiservPaymentExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentRequestsInitialState>
) => {
  const reducerId = 'paymentRequestFiservPayment';
  builder.addCase(paymentRequestFiservPayment.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(paymentRequestFiservPayment.fulfilled, (state, action) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
  builder.addCase(paymentRequestFiservPayment.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const resendPaymentRequestExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentRequestsInitialState>
) => {
  const reducerId = 'resendPaymentRequest';
  builder.addCase(resendPaymentRequest.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(resendPaymentRequest.fulfilled, (state, action) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    if (action.payload && action.payload.success && action.payload?.data) {
    } else {
    }
  });
  builder.addCase(resendPaymentRequest.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const updatePaymentRequestExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentRequestsInitialState>
) => {
  const reducerId = 'updatePaymentRequest';
  builder.addCase(updatePaymentRequest.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(updatePaymentRequest.fulfilled, (state, action) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    if (action.payload && action.payload.success && action.payload?.data) {
    }
  });
  builder.addCase(updatePaymentRequest.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const deletePaymentRequestExtraReducer = (
  builder: ActionReducerMapBuilder<PaymentRequestsInitialState>
) => {
  const reducerId = 'deletePaymentRequest';
  builder.addCase(deletePaymentRequest.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(deletePaymentRequest.fulfilled, (state, action) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    if (action.payload && action.payload.success && action.payload?.data) {
    }
  });
  builder.addCase(deletePaymentRequest.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
